import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: 'What is the difference between an executive resume and a board resume?',
    a: 'An executive resume focuses on operational leadership, P&L management, and team building. A board resume shifts the focus to governance, strategic oversight, risk management, and advising the CEO. We tailor the document specifically for nominating committees.'
  }, {
    q: 'How long does the resume writing process take?',
    a: 'Our standard turnaround time is 10-14 business days following the comprehensive career discovery phase. Expedited services are available for urgent opportunities.'
  }, {
    q: 'Do you optimize LinkedIn profiles for board searches?',
    a: 'Yes. LinkedIn optimization is a critical component of our executive branding strategy. We ensure your profile is positioned to attract executive search firms and board recruiters.'
  }, {
    q: 'What is included in an executive biography?',
    a: 'An executive bio is a narrative version of your career, highlighting your leadership philosophy, major milestones, and industry impact. It is often used for speaking engagements, company websites, and board introductions.'
  }, {
    q: 'How do you position a first-time board candidate?',
    a: 'We focus on your experience interacting with boards, your strategic vision, governance exposure, and specialized expertise (like cybersecurity, M&A, or digital transformation) that boards currently lack.'
  }, {
    q: 'Is my information kept confidential?',
    a: 'Absolutely. We adhere to strict confidentiality protocols. We regularly work with high-profile executives and understand the sensitivity of career transitions.'
  }, {
    q: 'What is your revision policy?',
    a: 'We work collaboratively with you. Our packages include two rounds of strategic revisions to ensure the final documents perfectly align with your goals and voice.'
  }, {
    q: 'Do you guarantee board placement?',
    a: 'While we cannot guarantee placement, we guarantee that your materials will be of the highest caliber, significantly improving your positioning and visibility with search firms and nominating committees.'
  }];
  return <section id="faq" className="py-24 bg-gray-50 border-t border-gray-200" data-id="element-134">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
        <div className="text-center mb-16" data-id="element-136">
          <h2 className="text-3xl md:text-5xl font-serif-display font-bold text-navy-900 mb-6" data-id="element-137">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-138">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-gray-200 rounded-sm overflow-hidden" data-id="element-139">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-140">
                <span className="font-bold text-navy-900 pr-8" data-id="element-141">{faq.q}</span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-gold flex-shrink-0" data-id="element-142" /> : <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-143" />}
              </button>

              {openIndex === index && <div className="px-6 pb-5 text-gray-600 leading-relaxed border-t border-gray-100 pt-4" data-id="element-144">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}